import Icon from "@mui/icons-material/Filter9Plus";
import { SequencesEdit } from "./SequencesEdit";
import { SequencesList } from "./SequencesList";

export default {
  list: SequencesList,
  edit: SequencesEdit,
  icon: Icon,
  label: "Sequences",
  options: { label: "Sequences" },
  name: "sequences",
};
